module.exports = __webpack_public_path__ + "img/CursorButton.de914327.svg";